export default __webpack_public_path__ + "static/media/tick.b9298f77.png";